module.exports = __webpack_public_path__ + "static/img/小程序.a98e796.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/小程序.jpg
// module id = oMh6
// module chunks = 11